import React from 'react'
import * as defaultConst from '../../constants/default_constants'
import * as linkConst from '../../constants/link_constants'
import EditView from 'bstrap-react-mobx-admin/view/edit'
import PropTypes from 'prop-types'
import SelectInput from '../input/select'
import TextArea from '../input/textArea'
import { Helmet } from 'react-helmet'

const FilmcargoHelpEditForm = ({ state }) => {
  const record = state.cv.record
  const errors = state.cv.errors
  const updateField = state.cv.updateData.bind(state.cv)
  const disabled = !state.hasRight(defaultConst.ENTNAMES.FILMCARGO_HELP, 'w')
  const items = state.options.has('filmcargo_help') && state.options.get('filmcargo_help').map(i => i.path)
  const itemName = record.has('path') &&
    state.options.get('filmcargo_help_elements') &&
    state.options.get('filmcargo_help_elements').find(f => f.value === record.get('path'))
  // filmcargo_help_elements -> in js/state/options.js

  return (
    <div className='row'>
      <Helmet title={state.__(linkConst.LINK_FILMCARGO_HELP_TITLE).concat(defaultConst.HTML_DIVIDER) + (record.has('id')
        ? ((itemName && itemName.label) || state.__(defaultConst.TITLE_EDIT))
        : state.__(defaultConst.TITLE_CREATE))} />
      <div className='col-sm-12 col-md-8 col-lg-8'>
        <SelectInput
          label={state.__('path')}
          attr={'path'}
          record={record}
          labelattr='label'
          valueattr='value'
          onChange={updateField}
          optionsrecord={state.options}
          optionsattr={'filmcargo_help_elements'}
          valueFilterFc={items && !record.has('id') ? i => items.includes(i.value) : undefined}
          disabled={record.has('id') || disabled}
          errors={errors} />
        <TextArea
          label={state.__('Value')}
          attr={'value'}
          record={record}
          onChange={updateField}
          errors={errors} disabled={disabled} />
      </div>
    </div>
  )
}

FilmcargoHelpEditForm.propTypes = {
  state: PropTypes.object.isRequired
}

const FilmcargoHelpEditView = ({ store }) => {
  if (!store.hasRight(defaultConst.ENTNAMES.FILMCARGO_HELP)) {
    return <h1>{store.__('insufficient rights')}</h1>
  }

  return (
    <EditView store={store.cv} onReturn2list={store.onReturn2list.bind(store)}
      enabled={store.hasRight(defaultConst.ENTNAMES.FILMCARGO_HELP, 'w')} >
      <FilmcargoHelpEditForm state={store} />
    </EditView>
  )
}

FilmcargoHelpEditView.propTypes = {
  store: PropTypes.object.isRequired
}

export default FilmcargoHelpEditView
